import { lightningShaderSource } from "./shaders";

function compile(gl: WebGL2RenderingContext, type: number, source: string): WebGLShader {
  const shader = gl.createShader(type);
  if (!shader) {
    throw new Error("Unable to allocate lightning shader");
  }
  gl.shaderSource(shader, source);
  gl.compileShader(shader);
  if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
    const message = gl.getShaderInfoLog(shader) ?? "unknown shader compiler error";
    gl.deleteShader(shader);
    throw new Error(`Unable to compile lightning shader: ${message}`);
  }
  return shader;
}

export function createLightningProgram(gl: WebGL2RenderingContext): WebGLProgram {
  const vertex = compile(gl, gl.VERTEX_SHADER, lightningShaderSource("lightning.vert.glsl"));
  const fragment = compile(gl, gl.FRAGMENT_SHADER, lightningShaderSource("lightning.frag.glsl"));
  const program = gl.createProgram();
  if (!program) {
    gl.deleteShader(vertex);
    gl.deleteShader(fragment);
    throw new Error("Unable to allocate lightning shader program");
  }
  gl.attachShader(program, vertex);
  gl.attachShader(program, fragment);
  gl.linkProgram(program);
  gl.deleteShader(vertex);
  gl.deleteShader(fragment);
  if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
    const message = gl.getProgramInfoLog(program) ?? "unknown program linker error";
    gl.deleteProgram(program);
    throw new Error(`Unable to link lightning shader program: ${message}`);
  }
  return program;
}

export function createLightningPickingProgram(gl: WebGL2RenderingContext): WebGLProgram {
  const vertex = compile(gl, gl.VERTEX_SHADER, lightningShaderSource("picking.vert.glsl"));
  const fragment = compile(gl, gl.FRAGMENT_SHADER, lightningShaderSource("picking.frag.glsl"));
  const program = gl.createProgram();
  if (!program) {
    gl.deleteShader(vertex);
    gl.deleteShader(fragment);
    throw new Error("Unable to allocate lightning picking shader program");
  }
  gl.attachShader(program, vertex);
  gl.attachShader(program, fragment);
  gl.linkProgram(program);
  gl.deleteShader(vertex);
  gl.deleteShader(fragment);
  if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
    const message = gl.getProgramInfoLog(program) ?? "unknown shader linker error";
    gl.deleteProgram(program);
    throw new Error(`Unable to link lightning picking shader program: ${message}`);
  }
  return program;
}
